import { BodyVariant, SizeOptions } from '../../../../types/types'
import { AstraCheckboxProps } from '../../AstraCheckbox/AstraCheckbox'
import { SelectOption, SelectOptionGroup } from '../../AstraSelect'
import { MultiSelectOption } from '../types/types'

export const typographySizeStyles: Record<SizeOptions, BodyVariant> = {
    small: 'body-small',
    medium: 'body',
    large: 'body',
}

export const COLLAPSED_GROUP_PLACEHOLDER = '__dummy__'

export const isDummyOption = <T>(option: SelectOption<T>): boolean => typeof option.value === 'string' && option.value.startsWith(COLLAPSED_GROUP_PLACEHOLDER)

export const isGroup = <T>(option: MultiSelectOption<T>): option is SelectOptionGroup<T> => 'options' in option

export const getGroupByLabel = <T>(options: MultiSelectOption<T>[], label: string): SelectOptionGroup<T> | undefined => {
    const found = options.find(option => isGroup(option) && option.label === label)
    return found && isGroup(found) ? found : undefined
}

export const getGroupValues = <T>(group: SelectOptionGroup<T>) => group.options.map(option => option.value)

export const getGroupCheckboxState = <T>(group: SelectOptionGroup<T>, values: T[]): AstraCheckboxProps['checked'] => {
    const groupValues = getGroupValues(group)
    const selectedCount = groupValues.filter(groupValue => values.includes(groupValue)).length
    if (selectedCount === 0) return false
    if (selectedCount === groupValues.length) return true
    return 'indeterminate'
}

export const isOptionGrouped = <T>(option: SelectOption<T>, allOptions: MultiSelectOption<T>[]): boolean =>
    allOptions.some(opt => isGroup(opt) && opt.options.some(o => o.value === option.value))
